import { formatStatementPeriod } from '../../utils/format/statement-period';

const LinkedTransactionsSummary = ({ statement, checksum, t }) => {
  if (!statement) return null;
  const lastFour = String(statement.account_mask || '').match(/\d{4}$/)?.[0];
  const card = [statement.card_label, statement.card_type, lastFour && `•••• ${lastFour}`].filter(Boolean).join(' · ');
  const period = formatStatementPeriod(statement.start_date, statement.end_date, t.lang);
  return (statement.transactions || []).filter(transaction => transaction.checksum === checksum).map((transaction, index) => {
    const hasAmount = transaction.amount !== null && transaction.amount !== undefined && transaction.amount !== '' && Number.isFinite(Number(transaction.amount));
    const amount = hasAmount ? new Intl.NumberFormat(t.lang === 'fr' ? 'fr-CA' : 'en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(transaction.amount)) : null;
    const fields = [
      ['transaction', transaction.merchant_name || transaction.name],
      ['card', card],
      ['date', transaction.date?.slice(0, 10)],
      ['amount', amount && [amount, transaction.currency_code || statement.currency_code].filter(Boolean).join(' ')],
      ['statement', period],
    ].filter(([, value]) => value);
    if (!fields.length) return null;
    return <dl className='linked-transaction-summary' key={transaction.transaction_id || index}>
      {fields.map(([key, value]) => <div key={key}>
        <dt>{t.read(`review_expense.linked_transaction.${key}`)}</dt>
        <dd>{value}</dd>
      </div>)}
    </dl>;
  });
};

export default LinkedTransactionsSummary;
